import { ErrorLevel } from '../../models';
import { errorTextColor, successTextColor, warningTextColor } from '../../common/constants';

export class GaugeHelper {
    public static Colors = {
        red: errorTextColor,
        orange: warningTextColor,
        green: successTextColor
    };

    public static getDefaultBands(type?: string) {
        const prefix = type ? `Percentage of ${type}` : 'Percentage';
        return [
            { min: 0, max: 0.05, classed: 'fill-success', level: ErrorLevel.Success, message: `${prefix} is Ok`, color: GaugeHelper.Colors.green },
            { min: 0.05, max: 0.2, classed: 'fill-warn', level: ErrorLevel.Warning, message: `${prefix} is a bit too high`, color: GaugeHelper.Colors.orange },
            { min: 0.2, max: 1, classed: 'fill-error', level: ErrorLevel.Error, message: `${prefix} is too high`, color: GaugeHelper.Colors.red }
        ];
    }
}

